import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoSelectorComponent } from './video-selector/video-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { VideoCoreService } from './video-core.service';

@NgModule({
  declarations: [VideoSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [VideoCoreService],
  exports: [VideoSelectorComponent],
})
export class VideoCoreModule {}
